import { Typography, Checkbox, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

const ServiceItemCard = ({ 
  item, 
  isUtility = false, 
  isSelected, 
  quantity, 
  language,
  onToggle, 
  onQuantityChange 
}) => {
  return (
    <div className={`service-item ${isSelected ? "selected" : ""}`}>
      <div className="service-info">
        <Checkbox
          checked={isSelected}
          onChange={() => onToggle(item)}
          className="service-checkbox"
        />
        <div className="service-details">
          <Typography variant="subtitle1" className="service-name">
            {item.name[language]}
          </Typography>
          <Typography variant="body2" className="service-description">
            {item.description?.[language] ||
              (language === "ar"
                ? "خدمة صيانة احترافية بأيدي فنيين متخصصين"
                : "Professional maintenance service by specialized technicians")}
          </Typography>
        </div>
      </div>

      <div className="service-right-section">
        {isSelected && (
          <div className="quantity-controls">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onQuantityChange(item._id, -1, isUtility);
              }}
              className="quantity-button"
              disabled={quantity <= 1}
            >
              <RemoveIcon fontSize="small" />
            </IconButton>

            <span className="quantity-display">{quantity}</span>

            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                onQuantityChange(item._id, 1, isUtility);
              }}
              className="quantity-button"
            >
              <AddIcon fontSize="small" />
            </IconButton>
          </div>
        )}
        <div className="service-price-tag">
          <span>{item.price} ر.س</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceItemCard;